var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 968.029,
    height: 1714.465,
    viewBox: "0 0 968.029 1714.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_921",
    "data-name": "Group 921",
    transform: "translate(-80.489 -95.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 644.275, 95.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M230.672,0A185.966,185.966,0,0,0,112.256,42.345L5.055,82.193s-12.72,4.631,2.195,15.54C16.912,104.8,38,114.491,55.722,121.323A186.339,186.339,0,0,0,43.93,186.74c0,103.135,83.607,186.742,186.742,186.742s186.74-83.606,186.74-186.742S333.806,0,230.672,0Z",
    fill: "#ff99c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470",
    transform: "translate(154.405 145.391)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 18.399,
    cy: 18.399,
    rx: 18.399,
    ry: 18.399,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471",
    transform: "translate(268.012 145.391)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 18.399,
    cy: 18.399,
    rx: 18.399,
    ry: 18.399,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472",
    transform: "translate(172.471 223.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M58.194,40.438A67.385,67.385,0,0,1,.879,8.756,5.713,5.713,0,0,1,10.549,2.67,56.022,56.022,0,0,0,58.194,29.012,56.026,56.026,0,0,0,105.839,2.67a5.712,5.712,0,1,1,9.668,6.086A67.384,67.384,0,0,1,58.194,40.438Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    transform: "translate(594.201 741.213) rotate(16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M182.795,0A147.363,147.363,0,0,0,88.958,33.556L4.006,65.134s-10.08,3.67,1.74,12.314c7.656,5.6,24.371,13.279,38.412,18.694A148,148,0,1,0,182.795,0Z",
    fill: "#ef48b3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    transform: "translate(136.676 177.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M46.114,32.045A53.4,53.4,0,0,1,.7,6.94,4.527,4.527,0,0,1,4.527,0H87.7a4.527,4.527,0,0,1,3.831,6.94A53.4,53.4,0,0,1,46.114,32.045ZM13.726,9.054A44.327,44.327,0,0,0,46.114,22.991,44.329,44.329,0,0,0,78.5,9.054Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(122.359 115.215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M25.5.006a9.9,9.9,0,0,0-7.89,3.412,1.7,1.7,0,0,1-2.261.292A9.858,9.858,0,0,0,8.038,2.165C2.264,3.2-1.063,9.214.307,14.919,2.815,25.374,14.833,31.036,18.956,32.694a2.457,2.457,0,0,0,2.529-.423C25.158,29.1,36.4,18.476,34.872,8.38A9.941,9.941,0,0,0,25.5.006Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    transform: "translate(206.87 115.215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M9.511.006A9.9,9.9,0,0,1,17.4,3.418a1.7,1.7,0,0,0,2.261.292,9.86,9.86,0,0,1,7.313-1.546c5.774,1.039,9.1,7.049,7.732,12.754C32.2,25.374,20.182,31.036,16.059,32.694a2.456,2.456,0,0,1-2.529-.423C9.855,29.1-1.383,18.476.141,8.38A9.943,9.943,0,0,1,9.511.006Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_529",
    "data-name": "Group 529",
    transform: "translate(121.573 591.991) rotate(-14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M168.843,0A136.116,136.116,0,0,0,82.168,31L3.7,60.163s-9.311,3.389,1.607,11.375C12.379,76.71,27.818,83.8,40.787,88.8A136.706,136.706,0,1,0,168.843,0Z",
    fill: "#68cef4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527",
    transform: "translate(112.427 105.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 13.468,
    cy: 13.468,
    rx: 13.468,
    ry: 13.468,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526",
    transform: "translate(83.156 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 13.468,
    cy: 13.468,
    rx: 13.468,
    ry: 13.468,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528",
    transform: "translate(143.174 163.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M44.419,19.483a4.177,4.177,0,0,1-3.542-1.954,19.575,19.575,0,0,0-33.156,0A4.181,4.181,0,1,1,.643,13.074a27.937,27.937,0,0,1,47.311,0,4.182,4.182,0,0,1-3.535,6.409Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564",
    transform: "translate(80.489 1135.003) rotate(-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M194.794,0a157.035,157.035,0,0,0-100,35.759L4.269,69.409S-6.473,73.32,6.123,82.532c8.158,5.968,25.971,14.15,40.933,19.921A157.717,157.717,0,1,0,194.794,0Z",
    fill: "#089faf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556",
    transform: "translate(131.729 129.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 15.538,
    cy: 15.538,
    rx: 15.538,
    ry: 15.538,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555",
    transform: "translate(95.936 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 15.538,
    cy: 15.538,
    rx: 15.538,
    ry: 15.538,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557",
    transform: "translate(196.138 210.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M0,0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562",
    transform: "translate(123.754 82.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559",
    transform: "translate(96.412 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M41.72,19.448a4.8,4.8,0,0,1-2.5-.7C38.978,18.6,22.806,8.99,5.011,9.685A4.765,4.765,0,0,1,0,5.051,4.821,4.821,0,0,1,4.636.045c20.849-.826,38.842,10,39.6,10.457a4.826,4.826,0,0,1-2.516,8.946Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M4.829,19.447A4.826,4.826,0,0,1,2.315,10.5C3.071,10.042,21.066-.764,41.915.043a4.822,4.822,0,0,1,4.633,5.006A4.77,4.77,0,0,1,41.54,9.683C23.568,8.99,7.5,18.643,7.336,18.739A4.8,4.8,0,0,1,4.829,19.447Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563",
    transform: "translate(172.39 182.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M22.845,56.32C10.248,56.32,0,43.687,0,28.16S10.248,0,22.845,0,45.692,12.633,45.692,28.16,35.443,56.32,22.845,56.32Zm0-46.671c-7.154,0-13.2,8.477-13.2,18.511s6.043,18.512,13.2,18.512,13.2-8.477,13.2-18.512S30,9.649,22.845,9.649Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(647.529 1351.236) rotate(14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M228.38,0A184.115,184.115,0,0,0,111.14,41.925L5,81.377S-7.589,85.962,7.178,96.761c9.565,7,30.449,16.59,47.99,23.356a184.482,184.482,0,0,0-11.674,64.767c0,102.109,82.776,184.885,184.886,184.885s184.885-82.776,184.885-184.885S330.489,0,228.38,0Z",
    fill: "#c954ef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(164.708 213.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M106.393,57.374a18.819,18.819,0,0,1-6.9-1.322c-8.082-3.177-23.641-8.51-37.022-8.51-14.331,0-29.024,5.089-36.506,8.122h0A18.908,18.908,0,0,1,4.377,50.218,17.775,17.775,0,0,1,2.719,29.1,19.127,19.127,0,0,1,5.112,26C21.055,9.233,41.426,0,62.471,0s41.417,9.233,57.359,26a19.3,19.3,0,0,1,4.116,6.627A17.959,17.959,0,0,1,119.554,51.9,18.727,18.727,0,0,1,106.393,57.374ZM23.842,50.42h0ZM62.471,36.23c14.481,0,30.376,5.055,41.16,9.3a7.455,7.455,0,0,0,8-1.7,6.682,6.682,0,0,0,1.716-7.264,8.079,8.079,0,0,0-1.712-2.773C97.848,19.3,80.388,11.313,62.471,11.313S27.1,19.3,13.309,33.791a7.818,7.818,0,0,0-.97,1.259,6.572,6.572,0,0,0,.687,7.878,7.559,7.559,0,0,0,8.693,2.25h0C31.789,41.1,47.037,36.23,62.471,36.23Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    transform: "translate(155.356 157.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567",
    transform: "translate(105.573 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M32.56,34.317a5.645,5.645,0,0,1-1.957-.351L3.7,24.047a5.656,5.656,0,0,1-.515-10.395L30.086.572a5.656,5.656,0,1,1,4.947,10.173L20.064,18.024l14.452,5.328A5.657,5.657,0,0,1,32.56,34.317Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M5.663,34.312A5.656,5.656,0,0,1,3.185,23.569l14.968-7.277L3.7,10.962A5.656,5.656,0,0,1,7.615.348l26.9,9.921a5.656,5.656,0,0,1,.517,10.395L8.13,33.742A5.627,5.627,0,0,1,5.663,34.312Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(150.539 110.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    transform: "translate(102.912 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M44.862,32.9a5.632,5.632,0,0,1-1.209-.131C42.64,32.55,18.634,27.162,1.595,9.593A5.656,5.656,0,0,1,9.717,1.718c14.606,15.059,36.136,19.953,36.353,20A5.658,5.658,0,0,1,44.862,32.9Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M5.653,32.9A5.657,5.657,0,0,1,4.446,21.717c.247-.055,21.755-4.951,36.351-20a5.656,5.656,0,1,1,8.12,7.875C31.88,27.162,7.875,32.55,6.862,32.77A5.64,5.64,0,0,1,5.653,32.9Z",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/loginBackground.96a5aab4be78ecd6bd534d37f9cf2ba6.svg";
export { ForwardRef as ReactComponent };